import {EventEmitter, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpService} from '../../../../services/http.service';

@Injectable()
export class FileDownloaderServices {
    url = 'attachments';
    fileDownloadedEvent: EventEmitter<string> = new EventEmitter<string>();

    constructor(private httpService: HttpService) {
    }
    
    fileDownloaded(fileName) {
        this.fileDownloadedEvent.emit(fileName);
    }

    showFiles(params?: any): Observable<any> {
        return this.httpService.get(`/api/attachments`, { params });
    }
}
